import axios2 from '../api/axios';
export const warehouseService = {
    getWarehouseData,
    deletewarehouse,
    addwarehouse,
    getLastWarehouseId,
    getWarehouseEditData,
    editwarehouseData,
    getallwarehouses,
    stocktransfer,
    getallstocktransfers,
    updatestocktransferstatus,
    updatereceivedstocktransfer,
    syncstocktransfer
}


function getWarehouseData(page, pageSize, quickFilterText = null){ 
    return axios2.get(`/getwarehouseDetails?page=${page}&limit=${pageSize}&filterText=${quickFilterText}`, ((response) => {
       return response;   
    })).catch((error) => {
        console.log("error : ", error);
    })
}

function addwarehouse(values){
    return axios2.post('/savewarehousedetails',values,((response) => {
        return response;
    })).catch((error) => {
        console.log("Error: ", error);
    })
}

function deletewarehouse(id){
    return axios2.post(`/deletewarehouse?id=${id}`, ((response)=> {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })
}


function getLastWarehouseId(){
    return axios2.get('/getLastWarehouseId', ((response) => {
        return response;
    })).catch((error) => {
        console.log("error :", error);
    })
}

function getWarehouseEditData(id){
    return axios2.get(`/getWarehouseEditData?id=${id}`, ((response)=> {
        return response;
    })).catch((error) => {
        console.log("Error : ", error);
    })
}

function editwarehouseData(values){
    return axios2.post('/editwarehouse',{values}, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })
}

function getallwarehouses(){
    return axios2.get('/getallwarehouses', ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })
}

function stocktransfer(formdata){
    return axios2.post('/stocktransfer',formdata, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })  
}

function getallstocktransfers({status}){
    return axios2.get(`/getallstocktransfers?status=${status}`, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })
}

function updatestocktransferstatus(formdata){
    return axios2.post('/updatestocktransferstatus',formdata, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    })
}

function updatereceivedstocktransfer(formdata){
    return axios2.post('/updatereceivedstocktransfer',formdata, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    }) 
}

function syncstocktransfer(transferno){
     return axios2.get(`/syncstocktransfer?transferno=${transferno}`, ((response) => {
        return response;
    })).catch((error) => {
        console.log("error : ", error);
    }) 
}